import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { siteConfig } from './config'

import resources from './translations'

i18n.use(initReactI18next).init({
    resources,
    lng: siteConfig.lang,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false
    }
})

export const setLanguage = (_lng) => {
    i18n.changeLanguage(_lng)
}

export default i18n
